import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { MapContainer, Marker, TileLayer, Polyline, Popup } from 'react-leaflet';
import L from 'leaflet';

// Custom stop location icon
const stopIcon = new L.Icon({
    iconUrl: 'https://cdn-icons-png.flaticon.com/512/64/64113.png', // Replace with your desired icon
    iconSize: [30, 30],
    iconAnchor: [15, 30],
    popupAnchor: [0, -30],
});
const circleIcon = new L.DivIcon({
    html: '<div style="width: 10px; height: 10px; background: white; border-radius: 50%; border: 2px solid black;"></div>',
    className: '', // Remove default styles
    iconSize: [16, 16],
    iconAnchor: [8, 8],
});


function RouteMap({ stopLat, stopLon, userLocation, shapes = [], stops = [] }) {
    const fallbackCenter = userLocation || [stopLat, stopLon];

    const polylineBounds = useMemo(() => {
        const allPoints = shapes.flatMap((shape) =>
            shape.points.map((pt) => [pt.lat, pt.lon])
        );
        return allPoints.length ? L.latLngBounds(allPoints) : null;
    }, [shapes]);

    function getRandomColor(index) {
        const colors = ['#FF5733', '#33B5FF', '#9C27B0', '#4CAF50', '#FF9800', '#795548', '#009688', '#3F51B5'];
        return colors[index % colors.length];
    }

    return (
        <Box
            sx={{
                height: '50vh',
                width: '100%',
                borderRadius: 0,
                overflow: 'hidden',
                boxShadow: 1,
            }}
        >

            <MapContainer
                center={fallbackCenter}
                zoom={13}
                scrollWheelZoom={true}
                style={{ height: '100%', width: '100%' }}
                dragging={true}
                doubleClickZoom={false}
                keyboard={false}
                tap={false}
                bounds={polylineBounds ?? undefined}
            >
                <TileLayer
                    url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://carto.com/">CARTO</a> contributors'
                />

                {/* Main stop marker */}
                <Marker position={[stopLat, stopLon]} icon={stopIcon}>
                </Marker>

                {/* Related stop markers with popup */}
                {stops.map((s, index) => (
                    <Marker
                        key={s.stop_id || index}
                        position={[parseFloat(s.stop_lat), parseFloat(s.stop_lon)]}
                        icon={circleIcon}
                    >
                        <Popup>{s.stop_name}</Popup>
                    </Marker>
                ))}

                {/* Polylines */}
                {shapes.map((shape, index) => (
                    <Polyline
                        key={shape.shape_id}
                        positions={shape.points.map((pt) => [pt.lat, pt.lon])}
                        pathOptions={{ color: getRandomColor(index), weight: 4, opacity: 0.7 }}
                    />
                ))}
            </MapContainer>

        </Box>
    );
}

export default RouteMap;
